module.exports = __webpack_public_path__ + "30b30cf7efd627bda2b3c879a62a82f2.png";